import React, { memo } from 'react'

import { Button, Icon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { applyUseCasePreset } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

import { useCaseOptions } from './useCaseOptions'

const handleUseCaseClick = (id, preset) => {
  trackSettingsInteraction('use_case', id)
  applyUseCasePreset(id, preset)
}

function UseCaseSelector() {
  const t = useTranslation()
  const selectedUseCase = useThreeDStudioStore(state => state.modelSettings.selectedUseCase)

  return (
    <div className="use-case-selector">
      <div className="use-case-selector__header">
        <span className="cgt-body-base-semibold">{t('leftSide.useCase.title')}</span>
      </div>
      <div className="use-case-selector__grid">
        {useCaseOptions.map(({ id, icon, preset }) => {
          const isSelected = selectedUseCase === id

          return (
            <Button
              key={id}
              type="secondary"
              size="tiny"
              customClass={classnames('use-case-selector__card', isSelected && 'use-case-selector__card--selected')}
              onClick={() => handleUseCaseClick(id, preset)}
              data-testid={`use-case-selector-${id}`}
            >
              <div className="use-case-selector__card-header">
                <Icon
                  className="use-case-selector__card-icon"
                  svgComponent={icon}
                  color="darker"
                  size="small"
                  notSpaced
                />
                <span className="cgt-body-base-semibold">
                  {t(`leftSide.useCase.options.${id}.title`)}
                </span>
              </div>
              <p className="cgt-caption use-case-selector__card-description">
                {t(`leftSide.useCase.options.${id}.description`)}
              </p>
            </Button>
          )
        })}
      </div>
    </div>
  )
}

export default memo(UseCaseSelector)
